// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../../types';

export const ActionsWrapper = styled<any, Theme>('div')`
  padding-top: 1rem;

  > button:first-of-type {
    margin-bottom: .5rem;
  }
`;

export default null;
